import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: '4822ead0-b178-42d4-bdf1-38119dc75904', // Replace with your Azure AD app client ID
    authority: 'https://login.microsoftonline.com/50acb822-4159-4c8d-9cf8-be79222e16ce', // Replace with your tenant ID
  redirectUri: window.location.origin, // Use current domain for redirect
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
